export default __webpack_public_path__ + "static/media/blossom-logo.95d6fddf.jpg";